import * as serviceWorker from '../serviceWorker'
import { recordEvent } from '../observability/events'

export default function clearCache(): void {
  // if ('caches' in window) {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name)
    })
    void recordEvent({
      level: 'info',
      category: 'outro',
      action: 'cache_cleared',
      payload: { cacheCount: names.length },
    })
    serviceWorker.unregister()
    serviceWorker.register()
  })

  setTimeout(function () {
    window.location.reload()
  }, 500)
  // }
}
